import { UseFormSetValue } from "react-hook-form";
import { ISignForm, Reflex } from "../interfaces/ISignForm";

export const sizePriceTable = [
  // 400x200
  { width: 400, height: 200, reflex: Reflex.NORMAL, graffitiProtection: false, price: 325 },
  { width: 400, height: 200, reflex: Reflex.HIGH,   graffitiProtection: false, price: 395 },
  { width: 400, height: 200, reflex: Reflex.NORMAL, graffitiProtection: true,  price: 950 },
  { width: 400, height: 200, reflex: Reflex.HIGH,   graffitiProtection: true,  price: 1100 },
  // 400x300
  { width: 400, height: 300, reflex: Reflex.NORMAL, graffitiProtection: false, price: 395 },
  { width: 400, height: 300, reflex: Reflex.HIGH,   graffitiProtection: false, price: 495 },
  { width: 400, height: 300, reflex: Reflex.NORMAL, graffitiProtection: true,  price: 1200 },
  { width: 400, height: 300, reflex: Reflex.HIGH,   graffitiProtection: true,  price: 1300 },
  // 400x400
  { width: 400, height: 400, reflex: Reflex.NORMAL, graffitiProtection: false, price: 520 },
  { width: 400, height: 400, reflex: Reflex.HIGH,   graffitiProtection: false, price: 595 },
  { width: 400, height: 400, reflex: Reflex.NORMAL, graffitiProtection: true,  price: 1500 },
  { width: 400, height: 400, reflex: Reflex.HIGH,   graffitiProtection: true,  price: 1550 },
  // 500x200
  { width: 500, height: 200, reflex: Reflex.NORMAL, graffitiProtection: false, price: 345 },
  { width: 500, height: 200, reflex: Reflex.HIGH,   graffitiProtection: false, price: 450 },
  { width: 500, height: 200, reflex: Reflex.NORMAL, graffitiProtection: true,  price: 1100 },
  { width: 500, height: 200, reflex: Reflex.HIGH,   graffitiProtection: true,  price: 1200 },
  // 500x300
  { width: 500, height: 300, reflex: Reflex.NORMAL, graffitiProtection: false, price: 495 },
  { width: 500, height: 300, reflex: Reflex.HIGH,   graffitiProtection: false, price: 595 },
  { width: 500, height: 300, reflex: Reflex.NORMAL, graffitiProtection: true,  price: 1400 },
  { width: 500, height: 300, reflex: Reflex.HIGH,   graffitiProtection: true,  price: 1500 },
  // 500x400
  { width: 500, height: 400, reflex: Reflex.NORMAL, graffitiProtection: false, price: 650 },
  { width: 500, height: 400, reflex: Reflex.HIGH,   graffitiProtection: false, price: 695 },
  { width: 500, height: 400, reflex: Reflex.NORMAL, graffitiProtection: true,  price: 1800 },
  { width: 500, height: 400, reflex: Reflex.HIGH,   graffitiProtection: true,  price: 1900 },
  // 560x200
  { width: 560, height: 200, reflex: Reflex.NORMAL, graffitiProtection: false, price: 480 },
  { width: 560, height: 200, reflex: Reflex.HIGH,   graffitiProtection: false, price: 950 },
  { width: 560, height: 200, reflex: Reflex.NORMAL, graffitiProtection: true,  price: 1100 },
  { width: 560, height: 200, reflex: Reflex.HIGH,   graffitiProtection: true,  price: 1300 },
  // 560x400
  { width: 560, height: 400, reflex: Reflex.NORMAL, graffitiProtection: false, price: 670 },
  { width: 560, height: 400, reflex: Reflex.HIGH,   graffitiProtection: false, price: 1600 },
  { width: 560, height: 400, reflex: Reflex.NORMAL, graffitiProtection: true,  price: 1800 },
  { width: 560, height: 400, reflex: Reflex.HIGH,   graffitiProtection: true,  price: 2100 },
  // 600x200
  { width: 600, height: 200, reflex: Reflex.NORMAL, graffitiProtection: false, price: 450 },
  { width: 600, height: 200, reflex: Reflex.HIGH,   graffitiProtection: false, price: 1050 },
  { width: 600, height: 200, reflex: Reflex.NORMAL, graffitiProtection: true,  price: 1200 },
  { width: 600, height: 200, reflex: Reflex.HIGH,   graffitiProtection: true,  price: 1300 },
  // 600x300
  { width: 600, height: 300, reflex: Reflex.NORMAL, graffitiProtection: false, price: 675 },
  { width: 600, height: 300, reflex: Reflex.HIGH,   graffitiProtection: false, price: 1495 },
  { width: 600, height: 300, reflex: Reflex.NORMAL, graffitiProtection: true,  price: 1600 },
  { width: 600, height: 300, reflex: Reflex.HIGH,   graffitiProtection: true,  price: 1800 },
];

export interface PriceBreakdown {
  basePrice: number;
  reflexSurcharge: number;
  graffitiSurcharge: number;
  total: number;
}

export function getPriceBreakdown(sign: ISignForm): PriceBreakdown {
  const reflex = sign.reflex ?? Reflex.NORMAL;

  const basePrice =
    sizePriceTable.find(
      (s) =>
        s.width === sign.width &&
        s.height === sign.height &&
        s.reflex === Reflex.NORMAL &&
        s.graffitiProtection === false,
    )?.price ?? 0;

  const priceAfterReflex =
    sizePriceTable.find(
      (s) =>
        s.width === sign.width &&
        s.height === sign.height &&
        s.reflex === reflex &&
        s.graffitiProtection === false,
    )?.price ?? basePrice;

  const total =
    sizePriceTable.find(
      (s) =>
        s.width === sign.width &&
        s.height === sign.height &&
        s.reflex === reflex &&
        s.graffitiProtection === sign.graffitiProtection,
    )?.price ?? 0;

  const reflexSurcharge = priceAfterReflex - basePrice;
  const graffitiSurcharge = total - priceAfterReflex;

  return { basePrice, reflexSurcharge, graffitiSurcharge, total };
}

export function calculateSignPrice(
  sign: ISignForm,
  setValue: UseFormSetValue<ISignForm>,
): void {
  const { total } = getPriceBreakdown(sign);
  setValue("quantityPrice", total);
  setValue("totalPrice", total * sign.quantity);
}
